






























































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import {
  UserModel,
  UserStoreViewModel,
  ChartOfAccountViewModel,
  TemplateBuilding,
  UserStoreListViewModel,
} from '@/models/admin/users';

import { StoreModel, StoreViewModel, AvailabilityStatus } from '@/models/admin/store';
import { TeamModel } from '@/models/admin/team';
import { Department } from '@/models/admin/department';
import { Base } from '@/components/common/base';
import { Utils } from '@/helper/utils';
import { UserStoresViewModel } from '@/Alynk.dtos';
import { IDialogOption } from '@/models/dialog';
import {
  userService,
  availabilityService,
  shiftService,
  departmentService,
  teamService,
} from '@/shared';
import { ValidationRules } from '@/helper/enum';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    AppDialog: () => import('@/components/common/app.dialog.vue'),
    Grid: () => import('@/components/common/app.grid.vue'),
  },
})
export default class UserSavePage extends Base {
  public storeModel: UserStoreListViewModel = {
    departmentName: '',
    userId: '',
    storeName: '',
    storeId: null,
    accountOverrides: [],
    managerName: '',
    amountLimit: null,
    user: '',
    manager: '',
    noLimit: false,
    department: [],
    phonePrefix: '1',
    logisticPartsCounterPersonId: '',
    isIpRestricted: false,
    building: '',
    workingShift: []
  };
  public storeInfoByUserIdResponse: any = {};
  public user: UserModel = {};
  public form: any = {};
  public formFields: Array<VFields<any>> = [];
  public userId: string = '';
  public storeId: number = 0;
  public userDataId: string = '';
  public userDataCopy: any;
  public innerStoreId: number = 0;
  public userCurrentStoreId: number = 0;
  public requestProgress: boolean = false;
  public panel: number = 0;
  public actions: any[] = [];
  public headers: VHeaders[] = [];
  public itemWorkShift: any[] = [];
  public loadingShift: boolean = false;
  public pagination = new PaginationModel('shiftId', true, 5);
  public startDay: string = '';
  public endDay: string = '';
  public selectWorkShiftId: number = null;
  public workShiftGuid: string = '';
  // public workShift: any = {
  //   id: "",
  //   shiftId: 0,
  //   shiftName: "",
  //   startDay: 0,
  //   endDay: 0
  // }

  public itemDays: any[] = [
    { id: "1", text: "Monday" },
    { id: "2", text: "Tuesday" },
    { id: "3", text: "Wednesday" },
    { id: "4", text: "Thursday" },
    { id: "5", text: "Friday" },
    { id: "6", text: "Saturday" },
    { id: "7", text: "Sunday" },
  ];


  public storeShifts: any[] = [];
  public stores: StoreModel[] = [];
  public buildingList: TemplateBuilding[] = [];
  public selectedStore: StoreModel = {};
  public storeAccount: ChartOfAccountViewModel[] = [];
  public storeTeams: TeamModel[];
  public departments: Department[];
  public backToListStoreId: number = 0;
  public actualStoreId: number = 0;
  public copyStoreId: number = 0;
  public roles: string[];
  public disabledWorkPhone: boolean = true;
  public disabledStoreButton: boolean = false;
  public isShownCopy: boolean = false;
  public isCopyStoreInfo: boolean = false;
  public statusList: AvailabilityStatus[] = [];
  public userData: UserModel = {
    userStores: [],
  };
  public existingShiftDays: number[] = [];
  public currentShiftDays: number[] = [];

  public showSelectStorePopup: IDialogOption = {
    width: 600,
    title: 'Select Store',
    model: false,
    loading: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t('switchStoreDialog.btnText') as string,
    },
    onAction: (): void => {
      this.copyStoreData();
    },
  };

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToUser') {
      this.$router.push({
        name: 'admin.users.edit',
        params: { id: this.userId },
      });
    } else if (methodName === 'copyUser') {
      this.showStoreModel();
    } else if (methodName === 'backToUserWithParam') {
      this.$router.push({
        name: 'admin.store.users.edit',
        params: { id: this.userId },
      });
    } else if (methodName === 'submit') {
      if (this.form.$valid) {
        this.submitStore();
      } else {
        this.showAlert(false, 'Form is invalid!');
      }
    } else {
      this.resetMethodName(methodName);
    }

    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'users');

    // Toolbar
    this.isShownCopy = this.$route.params.innerStoreId ? false : true;
    // if(this.$route.params.innerStoreId && Number(this.$route.params.innerStoreId) > 0){
    //   this.isShownCopy =  true;
    // }else{
    //   this.isShownCopy =  false;
    // }
    const buttons = [];
    if (this.backToListStoreId) {
      buttons.push({
        id: '0',
        type: 'button',
        title: 'Back to User',
        disabled: false,
        visible: true,
        class: 'btn',
        label: 'Back',
        click: 'backToUserWithParam',
        icon: 'fas fa-arrow-left',
      });
    } else {
      buttons.push({
        id: '0',
        type: 'button',
        title: 'Back to User',
        disabled: false,
        visible: true,
        class: 'btn',
        label: 'Back',
        click: 'backToUser',
        icon: 'fas fa-arrow-left',
      });
      if (this.isShownCopy) {
        buttons.push({
          id: '1',
          type: 'button',
          title: 'Copy Store',
          disabled: false,
          visible: true,
          class: 'btn',
          label: 'Copy User Store',
          click: 'copyUser',
          icon: 'fas fa-copy',
        });
      }
    }
    this.$emit('updateToolBar', buttons);
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    this.setFields();
    this.innerStoreId = Number(this.$route.params.innerStoreId || 0);
    this.storeId =
      this.innerStoreId !== 0 ? Number(this.innerStoreId) : this.storeId;
    this.userId = this.$route.params.id;
    this.userCurrentStoreId = Number(this.$route.params.innerStoreId);
    if (this.userCurrentStoreId) {
      this.getData();
    } else {
      this.storeModel.userId = this.userId;
      this.getData();
    }
    this.GetUserDetailsByUserId();
    this.addWatcher();
    if (this.userCurrentStoreId) {
      this.formlyShowSkeleton(this.formFields);
    }

    this.setHeaders();
    this.setActions();
  }

  public async GetUserDetailsByUserId(): Promise<void> {
    try {
      const response = await userService.GetUserDetailsByUserId(
        this.$route.params.id
      );
      this.userData.userStores = response.userStores;
      this.storeModel.isIpRestricted = response.isIpRestricted;
      // this.setFields();
    } finally {
      //
    }
  }
  public showStoreModel() {
    this.showSelectStorePopup.model = true;
  }
  public addWatcher(): void {
    this.$watch('storeModel.storeId', (newVal, oldVal) => {
      if (newVal !== oldVal && newVal) {
        this.selectedStore =
          this.stores.find((m) => {
            return m.id.toString() === newVal;
          }) || {};
        this.userCurrentStoreId = this.storeModel.storeId;
        if (!this.isCopyStoreInfo) {
          this.getDataByStoreId(this.userCurrentStoreId);
        }
      }
    });
  }

  public async copyStoreData() {
    try {
      this.showSelectStorePopup.loading = true;
      const store = this.userData.userStores.find((st) => {
        return st.storeId === this.copyStoreId;
      });

      const response = await userService.getStoreDetailsByUserId(
        this.userId,
        store.storeId
      );
      this.storeModel.roles = response.storeInfoByUserIdResponse.roles;
      const workPhone = response.storeInfoByUserIdResponse.workPhone;
      this.storeModel.workPhone = workPhone.slice(2, workPhone.length);
      this.storeModel.serviceWriterId =
        response.storeInfoByUserIdResponse.serviceWriterId;
      this.storeModel.availabilityStatus =
        response.storeInfoByUserIdResponse.availabilityStatus;
      this.itemWorkShift = response.storeInfoByUserIdResponse.workingShift;
      if(response.storeInfoByUserIdResponse.shiftId >0){
      this.selectWorkShiftId = response.storeInfoByUserIdResponse.shiftId;
      this.storeModel.openRoRollOverNumber = response.storeInfoByUserIdResponse.openRoRollOverNumber;
      }
      this.setFields();
    } finally {
      this.showSelectStorePopup.model = false;
      this.showSelectStorePopup.loading = false;
    }
  }

  public setStoreInfo(): void {
    if (!this.user) {
      this.user = {};
    }

    this.storeModel = this.user.userStores
      ? this.user.userStores.find((m) => {
        return m.storeId === Number(this.innerStoreId);
      })
      : ({} as any);
    if (!this.storeModel) {
      this.storeModel = {} as any;
    }
    this.storeModel.userId = this.$route.params.id;
    this.selectedStore =
      this.stores.find((m) => {
        return m.id === Number(this.innerStoreId);
      }) || {};

    if (this.selectedStore.id) {
      this.storeModel.storeId = this.selectedStore.id;
      this.getUserStore();
    } else {
      this.storeModel.phonePrefix = '1';
    }
  }
  public setFields(): void {
    this.formFields = [
      {
        key: 'storeId',
        type: 'v-alynk-select',
        required: true,
        templateOptions: {
          counter: 500,
          label: this.$t('users.userStoreFields.store') as string,
          items: this.stores,
          text: 'storeJson.name',
          value: 'id',
          required: true,
          disabled: this.innerStoreId ? true : false,
          altag: 'Store',
          loading: false,
          elementClass:
            'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
          rules: [(v) => this.required('Store', v)],
        },
      },
      {
        key: 'openRoRollOverNumber',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          counter: 10,
          label: "Open Ro Roll Over",
          required: false,
          disabled: false,
          loading: false,
          elementClass:
            'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
          rules: [
            // (v) => this.required('Open RO Roll Over Number', v),
            (v) => this.PhoneNumber(v)
          ],
        },
      },
      {
        key: 'building',
        type: 'v-alynk-select',
        templateOptions: {
          counter: 500,
          label: 'Buildings',
          items: this.buildingList,
          text: 'value',
          value: 'id',
          multiple: false,
          disabled: false,
          altag: 'Building',
          loading: false,
          elementClass:
            'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'isIpRestricted',
        type: 'v-alynk-switch',
        required: true,
        templateOptions: {
          label: 'Ip Restricted',
          validations: '',
          required: true,
          disabled: false,
          loading: false,
          elementClass:
            'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 py-0 pl-0 float-left',
        },
      },
      {
        key: 'serviceWriterId',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 20,
          label: this.$t('users.userStoreFields.serviceWriterId') as string,
          required: true,
          disabled: false,
          loading: false,
          elementClass:
            'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
          rules: [(v) => this.required('Service Writer Id', v)],
        },
      },
      {
        key: 'canSeeCallDetails',
        type: 'v-alynk-switch',
        required: true,
        templateOptions: {
          label: this.$t(
            'users.userStoreFields.allowViewCallDetails'
          ) as string,
          required: true,
          disabled: false,
          loading: false,
          elementClass:
            'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 py-0 pl-0 float-left',
        },
      },
      {
        key: 'logisticPartsCounterPersonId',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          counter: 20,
          label: this.$t(
            'users.userStoreFields.partsCounterpersonId'
          ) as string,
          required: false,
          disabled: false,
          loading: false,
          elementClass:
            'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 py-0 pl-0 float-left',
        },
      },
      {
        key: 'phonePrefix',
        type: 'v-alynk-phone-field',
        required: false,
        templateOptions: {
          counter: 2,
          label: this.$t('users.userStoreFields.prefix') as string,
          validations: 'required',
          required: false,
          disabled: this.disabledWorkPhone,
          // elementClass: 'flex xs4 sm12 md6 lg6 pr-2',
          // elementStyle: 'float:left;',
          elementClass:
            'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 py-0 pl-0 float-left',
          loading: false,
        },
      },

      {
        key: 'workPhone',
        type: 'v-alynk-text-field',
        required: true,
        validators: {
          workPhone: (field, model, next) => {
            next(Utils.PhoneNoRegex.test(model[field.key]));
          },
        },
        templateOptions: {
          counter: 10,
          label: this.$t('users.userStoreFields.workPhone') as string,
          hint: Utils.PhoneNoHint,
          required: true,
          disabled: false,
          loading: false,
          elementClass:
            'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 py-0 pl-0 float-left',
          rules: [
            (v) => this.required('Work Phone', v),
            (v) => this.PhoneNumber(v)
          ],
        },
      },
      {
        key: 'roles',
        type: 'v-alynk-select',
        required: true,
        templateOptions: {
          label: this.$t('users.userStoreFields.roles') as string,
          multiple: true,
          required: true,
          items: this.roles,
          text: 'name',
          value: 'name',
          disabled: false,
          altag: 'Roles',
          loading: false,
          elementClass:
            'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
          rules: [(v) => this.requiredForArray('Roles', v)],
        },
      },
      {
        key: 'availabilityStatus',
        type: 'v-alynk-select',
        required: true,
        templateOptions: {
          label: this.$t('users.userStoreFields.availabilityStatus') as string,
          required: true,
          disabled: false,
          time: true,
          items: this.statusList,
          text: 'status',
          value: 'id',
          altag: 'Availability Status',
          loading: false,
          elementClass:
            'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
          rules: [(v) => this.required('Availability Status', v)],
        },
      },

      // {
      //   key: 'shiftId',
      //   type: 'v-alynk-select',
      //   templateOptions: {
      //     label: this.$t('users.userStoreFields.shift') as string,
      //     disabled: false,
      //     time: true,
      //     value: 'value',
      //     text: 'text',
      //     items: this.storeShifts,
      //     altag: 'Shift',
      //     loading: false,
      //     elementClass:
      //       'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
      //   },
      // },
      {
        key: 'departmentName',
        type: 'v-alynk-select',
        templateOptions: {
          counter: 500,
          label: this.$t('users.userStoreFields.department') as string,
          items: this.departments,
          text: 'name',
          value: 'name',
          multiple: false,
          disabled: false,
          altag: 'Department',
          loading: false,
          elementClass:
            'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'accountOverrides',
        type: 'v-alynk-select',
        required: false,
        templateOptions: {
          counter: 500,
          label: this.$t('users.userStoreFields.accountOverrides') as string,
          validations: '',
          items: this.storeAccount,
          text: 'accountNumber',
          value: 'accountNumber',
          multiple: true,
          required: false,
          disabled: false,
          altag: 'Account Overrides',
          loading: false,
          elementClass:
            'col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-0 float-left',
        },
      },
      {
        key: 'vendorOverrides',
        type: 'v-alynk-vendors',
        required: false,
        templateOptions: {
          counter: 500,
          label: this.$t('users.userStoreFields.vendorOverrides') as string,
          validations: '',
          required: false,
          events: {
            search: this.checkVendorExists,
          },
          disabled: false,
          loading: false,
          elementClass:
            'col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 float-left',
        },
      },
    ];
  }

  public validateStore(): Vue & { validate: () => boolean } {
    return this.$refs.storeForm as Vue & { validate: () => boolean };
  }

  public async submitStore(): Promise<void> {
    if (this.validateStore().validate()) {
      try {
        this.requestProgress = true;
        this.$emit('update:progress', this.requestProgress);

        if (!this.storeModel.storeId) {
          this.showAlert(false, 'Please select store');
          return;
        }
        const smodel: UserStoreListViewModel = {
          userId: this.storeModel.userId,
          storeName: this.storeModel.storeName,
          innerStoreId: this.storeModel.innerStoreId,
          storeId: this.storeModel.storeId,
          departmentName: this.storeModel.departmentName,
          departmentId: this.storeModel.departmentId,
          accountOverrides: this.storeModel.accountOverrides,
          storeTeams: this.storeModel.storeTeams,
          userStoreTeams: this.storeModel.userStoreTeams,
          vendorOverrides: this.storeModel.vendorOverrides,
          serviceWriterId: this.storeModel.serviceWriterId,
          canSeeCallDetails: this.storeModel.canSeeCallDetails,
          workPhone: this.storeModel.workPhone,
          availabilityStatus: this.storeModel.availabilityStatus,
          alternatePhoneNumber: this.storeModel.alternatePhoneNumber,
          alternateUserId: this.storeModel.alternateUserId,
          shiftId: this.storeModel.shiftId,
          roles: this.storeModel.roles,
          managerName: this.storeModel.managerName,
          amountLimit: this.storeModel.amountLimit,
          user: this.storeModel.user,
          manager: this.storeModel.manager,
          noLimit: this.storeModel.noLimit,
          department: this.storeModel.department,
          phonePrefix: this.storeModel.phonePrefix,
          logisticPartsCounterPersonId: this.storeModel
            .logisticPartsCounterPersonId,
          isIpRestricted: this.storeModel.isIpRestricted,
          building: this.storeModel.building,
          workingShift: this.itemWorkShift,
          openRoRollOverNumber: this.storeModel.openRoRollOverNumber
        };
        smodel.workPhone = '+' + smodel.phonePrefix + smodel.workPhone;
        if (this.departments.length > 0) {
          if (typeof smodel.departmentName === 'undefined') {
            this.showAlert(false, 'Please select department');
            return;
          }
        }

        await userService.saveUserStoreAsync(smodel, this.innerStoreId);

        this.showAlert(true, this.$t('users.alertUserStoreUpdated'));
        const existing = this.user.userStores
          ? this.user.userStores.find((m) => {
            return m.storeId === this.storeModel.storeId;
          })
          : ({} as any);
        if (!existing) {
          this.storeModel.storeName = (
            this.stores.find((m) => {
              return m.id === this.storeModel.storeId;
            }) || { storeJson: {} as any }
          ).storeJson.name;
          this.storeModel.departmentName = (
            this.departments.find((m) => {
              return m.name === this.storeModel.departmentName;
            }) || { name }
          ).name;
          this.user.userStores.push(this.storeModel);
        } else {
          existing.accountOverrides = this.storeModel.accountOverrides;
          existing.departmentName = this.storeModel.departmentName;
          existing.vendorOverrides = this.storeModel.vendorOverrides;
        }

        if (this.backToListStoreId) {
          this.$router.push({
            name: 'admin.store.users.edit',
            params: {
              id: this.userId,
            },
          });
        } else {
          this.$router.push({
            name: 'admin.users.edit',
            params: {
              id: this.userId,
            },
          });
        }
      } finally {
        this.requestProgress = false;
        this.$emit('update:progress', this.requestProgress);
      }
    }
  }

  public setSelectItems(key, items) {
    const field = this.formFields.find((m) => {
      return m.key === key;
    });
    if (field) {
      field.templateOptions.items = items;
    }
  }

  public async getData(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.formFields, 'storeId');
      this.formlyShowSkeleton(this.formFields, 'roles');
      this.formlyShowSkeleton(this.formFields, 'availabilityStatus');
      this.formlyShowSkeleton(this.formFields, 'shiftId');
      this.formlyShowSkeleton(this.formFields, 'building');
      this.loadingShift = true;

      if (this.innerStoreId == null && this.innerStoreId) {
        this.userCurrentStoreId = 0;
      } else {
        this.userCurrentStoreId = Number(this.innerStoreId);
      }

      const response = await userService.getStoreDetailsByUserId(
        this.userId,
        this.innerStoreId
      );
      this.stores = response.notLinkedStoreByUserIdResponse as any;
      this.setSelectItems('storeId', this.stores);
      this.storeInfoByUserIdResponse =
        response.storeInfoByUserIdResponse || ({} as any);
      this.setStoreInfo();

      this.roles = response.rolesResponse;
      this.setSelectItems('roles', this.roles);

      this.statusList = response.avalabilityStatusResponse;
      this.setSelectItems('availabilityStatus', this.statusList);
      this.itemWorkShift = response.storeInfoByUserIdResponse.workingShift;
      if(response.storeInfoByUserIdResponse.shiftId >0){
      this.selectWorkShiftId = response.storeInfoByUserIdResponse.shiftId;
      }

      this.storeShifts = response.storeShiftsResponse;
      this.buildingList = response.templateBuildings;
      this.setSelectItems('shiftId', this.storeShifts);
    } finally {
      if (!this.userCurrentStoreId) {
        this.formlyHideSkeleton(this.formFields, 'storeId');
        this.formlyHideSkeleton(this.formFields, 'roles');
        this.formlyHideSkeleton(this.formFields, 'availabilityStatus');
        this.formlyHideSkeleton(this.formFields, 'shiftId');
        this.formlyHideSkeleton(this.formFields, 'building');
        this.loadingShift = false;
      }
    }
  }

  public async getDataByStoreId(userCurrentStoreId: number): Promise<void> {
    try {
      this.formlyShowSkeleton(this.formFields, 'departmentName');
      this.formlyShowSkeleton(this.formFields, 'accountOverrides');
      const response = await userService.getStoreDetailsByStoreId(
        userCurrentStoreId
      );
      this.departments = response.storeDepartmentbyStoreIdReponse;
      this.setSelectItems('departmentName', this.departments);

      this.storeAccount = response.accountOverridersResponse || [];
      this.setSelectItems('accountOverrides', this.storeAccount);
    } finally {
      this.setFields();
      this.formlyHideSkeleton(this.formFields, 'departmentName');
      this.formlyHideSkeleton(this.formFields, 'accountOverrides');
    }
  }

  public async getUserStore(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.formFields);
      this.loadingShift = true;
      if (this.userId && this.innerStoreId) {
        this.storeModel = this.storeInfoByUserIdResponse;
        // prefix change
        this.disabledWorkPhone = true;
        if (this.storeModel.workPhone == undefined) {
          this.storeModel.phonePrefix = '1';
        }
        if (this.storeModel.workPhone.length >= 10) {
          this.storeModel.workPhone = this.storeModel.workPhone.replace(
            '+',
            ''
          );
          const workPhone = this.storeModel.workPhone;
          this.storeModel.workPhone = workPhone.substring(
            workPhone.length,
            workPhone.length - 10
          );
          if (workPhone.includes('undefined')) {
            const workPhoneNumber = workPhone.replace('undefined', '1');
            this.storeModel.phonePrefix = workPhoneNumber.substring(0, 1);
          } else {
            this.storeModel.phonePrefix = workPhone.substring(
              workPhone.length - 10,
              0
            );
          }
          if (!this.storeModel.phonePrefix) {
            this.storeModel.phonePrefix = '1';
          }
          this.disabledWorkPhone = this.storeModel.phonePrefix === '1';
        } else {
          this.storeModel.phonePrefix = '1';
        }

        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < this.formFields.length; i++) {
          if (this.formFields[i].key === 'phonePrefix') {
            this.formFields[
              i
            ].templateOptions.disabled = this.disabledWorkPhone;
          }
        }
        this.storeModel.departmentName = this.storeModel.departmentName || '';
      }
    } finally {
      this.formlyHideSkeleton(this.formFields);
      this.loadingShift = false;
    }
  }

  public async checkVendorExists(vendor, callback): Promise<void> {
    if (!vendor) {
      this.showAlert(false, this.$t('users.alertFillVendorField'));
      return;
    }
    if (this.userCurrentStoreId) {
      try {
        this.formlyShowSkeleton(this.formFields, 'vendorOverrides');
        await userService.checkVendorAsync(vendor, this.userCurrentStoreId);
        this.storeModel.vendorOverrides = this.storeModel.vendorOverrides || [];
        const index = this.storeModel.vendorOverrides.indexOf(vendor);
        if (index === -1) {
          this.storeModel.vendorOverrides.push(vendor);
          if (typeof callback === 'function') {
            callback();
          }
        }
      } finally {
        this.formlyHideSkeleton(this.formFields, 'vendorOverrides');
      }
    }
  }

  public setActions() {
    this.actions = [
      {
        type: 'button',
        icon: 'fas fa-trash-alt',
        title: 'Delete',
        color: 'error',
        action: (model: any) => {
          this.deleteWorkShift(model);
        },
      },
    ];
  }

  public setHeaders() {
    this.headers = [
      {
        text: 'Start Day',
        align: 'left',
        value: 'startDay',
        sortable: false,
        fieldType: 'template',
        template: (item) => {
          if (item.startDay != "") {
            return `<div style='display:flex;justify-content:center'><span>${this.GetWeekNameFromList(item.startDay)}</span></div>`;
          }
        }
      },
      {
        text: 'End Day',
        align: 'left',
        value: 'endDay',
        sortable: false,
        fieldType: 'template',
        template: (item) => {
          if (item.endDay != "") {
            return `<div style='display:flex;justify-content:center'><span>${this.GetWeekNameFromList(item.endDay)}</span></div>`;
          }
        }
      },
      {
        align: 'left',
        sortable: true,
        text: "Shift",
        value: 'shiftName',
      },
      {
        align: 'center',
        isNotDataProp: true,
        text: 'Action',
        sortable: false,
      }
    ];
  }

  public async addWorkShift(): Promise<void> {
    if (!(await this.validateFormByScope('shiftData'))) {
      return;
    } else {
    let isShiftExist = this.checkWeekDaysExist();
      if(!isShiftExist){
        let currentShift = this.storeShifts.find(x => x.value == this.selectWorkShiftId);
        let workShift = {
          shiftId : this.selectWorkShiftId,
          startDay : this.startDay,
          endDay : this.endDay,
          shiftName : currentShift.text
        };
        this.itemWorkShift.push(workShift);
        }
      else{
        this.showAlert(false, "this work shift day already exist." );
      }
    }
  }


  public updatePaging(paging: any) {
    this.pagination = paging;
  }

  public GetWeekNameFromList(weekDayId) {
    let weekDayName = this.itemDays.find(x => x.id == weekDayId);
    return weekDayName.text;
  }

  public deleteWorkShift(item) {
    const index = this.itemWorkShift.indexOf(item);
    if (index > -1) {
      this.itemWorkShift.splice(index, 1);
    }
  }

  public addDaysOfWeek(shiftStartDay: number, shiftEndDay: number, shiftDays: number[]): number[] {
    // Handle normal range (e.g., Wednesday to Friday)
    if (shiftStartDay <= shiftEndDay) {
      for (let dayOfWeek = shiftStartDay; dayOfWeek <= shiftEndDay; dayOfWeek++) {
        if (!shiftDays.includes(dayOfWeek)) {
          shiftDays.push(dayOfWeek);
        }
      }
    }

    // Handle wrap-around range (e.g., Saturday to Tuesday)
    if (shiftStartDay > shiftEndDay) {
      // Add days from start day to end of week
      for (let dayOfWeek = shiftStartDay; dayOfWeek <= 7; dayOfWeek++) {
        if (!shiftDays.includes(dayOfWeek)) {
          shiftDays.push(dayOfWeek);
        }
      }

      // Add days from start of week to end day
      for (let dayOfWeek = 1; dayOfWeek <= shiftEndDay; dayOfWeek++) {
        if (!shiftDays.includes(dayOfWeek)) {
          shiftDays.push(dayOfWeek);
        }
      }
    }

    return shiftDays;
  }

  public checkWeekDaysExist() {
    if(this.itemWorkShift.length == 0){
      return false;
    }
    this.itemWorkShift.forEach((shift: any) => {
        this.addDaysOfWeek(Number(shift.startDay), Number(shift.endDay), this.existingShiftDays);
    });
    this.addDaysOfWeek(Number(this.startDay), Number(this.endDay), this.currentShiftDays);
    // Check if any of the current shift days overlap with existing shift days
    if (this.currentShiftDays.some(currentShiftDay => this.existingShiftDays.includes(currentShiftDay))) {
      this.existingShiftDays = [];
      this.currentShiftDays =[];
      return true;
    }
    this.existingShiftDays = [];
    this.currentShiftDays =[];
    return false;
  }
}
